import React from "react";
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";
import "../../DataTable/DataTable.css";

/**
 * Las facturas descargadas del SAT, con el mismo aspecto que el resto de las
 * tablas: barra arriba con el buscador y cuántas filas ver, y el contenido con
 * scroll propio cuando hay más columnas de las que caben.
 */
export default function Table({
  contabilidad,
  pageSizes,
  pageSize,
  handlePageSizeChange,
  buscador,
  setbuscador,
}) {
  return (
    <div className="dtable-wrap">
      <div className="dtable-toolbar">
        <label className="dtable-tamano">
          Ver
          <select
            className="dtable-tamano-select"
            onChange={handlePageSizeChange}
            value={pageSize}
          >
            {pageSizes.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
          por página
        </label>
        <div className="dtable-search">
          <i className="bi bi-search" aria-hidden="true"></i>
          <input
            type="search"
            className="dtable-search-input"
            value={buscador}
            onChange={(e) => setbuscador(e.target.value)}
            placeholder="Buscar en la tabla..."
            aria-label="Buscar en la tabla"
          />
        </div>
      </div>
      <div className="dtable-scroll">
        <table className="dtable">
          <TableHeader key={"contabilidad"} />
          <TableBody contabilidad={contabilidad} />
        </table>
      </div>
    </div>
  );
}
